import { configureStore } from '@reduxjs/toolkit';
import authReducer from './page/auth/authSlice';
import NotesReducer from './apps/notes/NotesSlice';
import CustomizerReducer from './customizer/CustomizerSlice';
import ChatsReducer from './apps/chat/ChatSlice';
import ContactsReducer from './apps/contacts/ContactSlice';
import EmailReducer from './apps/email/EmailSlice';
import TicketReducer from './apps/ticket/TicketSlice';
import UfDimensionallyObsReducer from './page/material/materialSlice';
import frametypeReducer from './page/frametype/frametypeSlice';
import metalSheetSliceReducer from './page/metalSheet/metalSheetSlice';
import underFrameReducer from './page/underFrame/underFrameSlice';
import roleSliceReducer from './page/role/roleSlice';
import endWallReducer from './page/endwall/endWallSlice';
import roofReducer from './page/roof/roofSlice';
import sideWallReducer from './page/sideWall/sideWallSlice';
import assemblyReducer from './page/assembly/assemblySlice';
import finalInspectionReducer from './page/finalInspection/finalInspectionSlice';
import dashboardReducer from './page/dashboard/dashboardSlice';
import paintReducer from './page/paint/paintSlice';
import frontPartReducer from './page/frontpart/frontpartSlice';
import boggieReducer from './page/boggie/boggieSlice';
import clearanceReducer from './page/clearance/clearanceSlice';
import wheelReducer from './page/wheel/wheelSlice';
import electricalReducer from'./page/elecrtical/electricalSlice';
import furnishingReducer from './page/furnishing/furnishingSlice';
import furnishingTestingReducer from './page/furnishingTesting/furnishingTestingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    customizer: CustomizerReducer,
    notesReducer: NotesReducer,
    chatReducer: ChatsReducer,
    contactsReducer: ContactsReducer,
    emailReducer: EmailReducer,
    ticketReducer: TicketReducer,
    ufDimensionallyObsReducer: UfDimensionallyObsReducer,
    frametypesReducer: frametypeReducer,
    metalSheetReducer: metalSheetSliceReducer,
    sideWallsReducer: sideWallReducer,
    roleReducer: roleSliceReducer,
    underFrameReducer,
    endWallReducer,
    roofReducer,
    assemblyReducer,
    finalInspectionReducer,
    dashboardSReducer: dashboardReducer,
    paintReducer,
    frontPartReducer,
    boggieReducer,
    clearanceReducer,
    wheelReducer,
    electricalReducer,
    furnishingReducer,
    furnishingTestingReducer
    
  },
});

export default store;
